import Vue from 'vue';
import * as types from '../mutation-types';


// initial state
const state = {
  adminBusy: false,
  adminOffset: 0,
  adminInfo: {},
  adminList: [],
};

// getters
const getters = {
  adminBusy: stateFreezed => stateFreezed.adminBusy,
  adminList: stateFreezed => stateFreezed.adminList,
  adminInfo: stateFreezed => stateFreezed.adminInfo,
};

// actions
const actions = {
  fetchAdminList({ commit }, tag) {
    commit(types.ADMIN_LIST_BUSY, true);
    Vue.http.get(`refs/?offset=${state.adminOffset}&tag=${tag}`)
    .then((response) => {
      if (response.body.results) {
        commit(types.RECEIVE_ADMIN_LIST, response.body);
        commit(types.ADMIN_LIST_OFFSET);
        if (response.body.next) commit(types.ADMIN_LIST_BUSY, false);
      }
    });
  },
  voteAdminImg({ commit, dispatch }, params) {
    Vue.http.post(`refs/${params.ref.id}/estimate/`, { value: params.value }, { emulateJSON: true });
    commit(types.UPDATE_ADMIN_LIST_VOTE, { key: params.key, value: params.value });
  },
  TagAdminImg({ commit, dispatch }, params) {
    Vue.http.put(`refs/${params.id}/`, JSON.stringify({ tags: [params.tags] }), { emulateJSON: true });
    commit(types.UPDATE_ADMIN_LIST, params.number);
  },
  deleteAdminImg({ commit, dispatch }, params) {
    Vue.http.delete(`refs/${params.id}/`);
    commit(types.UPDATE_ADMIN_LIST, params.number);
  },
};

// mutations
const mutations = {
  [types.RECEIVE_ADMIN_LIST](stateFreezed, adminFetched) {
    const st = stateFreezed;
    st.adminInfo = adminFetched;
    st.adminList = st.adminList.concat(adminFetched.results);
  },
  [types.UPDATE_ADMIN_LIST](stateFreezed, key) {
    const st = stateFreezed;
    st.adminList.splice(key, 1);
  },
  [types.UPDATE_ADMIN_LIST_VOTE](stateFreezed, params) {
    const st = stateFreezed;
    st.adminList[params.key].has_estimated = params.value;
  },
  [types.ADMIN_LIST_OFFSET](stateFreezed) {
    const st = stateFreezed;
    st.adminOffset += 20;
  },
  [types.ADMIN_LIST_BUSY](stateFreezed, status) {
    const st = stateFreezed;
    st.adminBusy = status;
  },
  [types.CLEAR_ADMIN_LIST](stateFreezed) {
    const st = stateFreezed;
    st.adminBusy = false;
    st.adminOffset = 0;
    st.adminList = [];
  },
  [types.TAG_ADMIN_UPDATE](stateFreezed, params) {
    const st = stateFreezed;
    const updatedList = st.adminList;
    const updatedRef = st.adminList[params.key];
    updatedRef.tags = [params.tag];
    Vue.set(updatedList, params.key, updatedRef);
    st.adminList = updatedList;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/admin.js